module.exports = __webpack_public_path__ + "img/header-mae-elenials.1a9219f1.svg";